import { createApp } from './main';
import { setupFirebaseClient } from './plugins/firebase-client';

const { app, router } = createApp();

function updateMeta(route) {
	const meta = route.meta || {};
	const defaultDescript = `Introduce GB WhatsApp and offer Secure version of GBWhatsApp that has resolved login issues. Download and Update GBWhatsApp by AlexMODs, which has extra features like the best AI image generator. `;
	const defaultKeyword = 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download';
	document.title = meta.title || 'GB WhatsApp|GB WhatsApp Pro APK Download  v18.40 2024(Anti-Ban)';
	const defaultCanonical = 'https://gbwhtas.com/';

	setMetaTag('description', meta.description || defaultDescript);
	setMetaTag('og:description', meta.description || defaultDescript);
	setMetaTag('keywords', meta.keywords || defaultKeyword);
	setLinkTag('canonical', meta.link?.find((link) => link.rel === 'canonical')?.href || defaultCanonical);
	replaceHreflangLinks(meta.hreflangHtml || '');

	if (meta.noindex) {
		setMetaTag('robots', 'noindex');
	} else {
		setMetaTag('robots', 'index,follow');
	}
}

function setMetaTag(name, content) {
	let element = document.querySelector(`meta[name="${name}"]`);
	if (element) {
		element.setAttribute('content', content);
	} else {
		element = document.createElement('meta');
		element.setAttribute('name', name);
		element.setAttribute('content', content);
		document.head.appendChild(element);
	}
}

function setLinkTag(rel, href) {
	let element = document.querySelector(`link[rel="${rel}"]`);
	if (element) {
		element.setAttribute('href', href);
	} else {
		element = document.createElement('link');
		element.setAttribute('rel', rel);
		element.setAttribute('href', href);
		document.head.appendChild(element);
	}
}

/** 路由切换时替换 hreflang alternate，避免残留上一页语言映射 */
function replaceHreflangLinks(hreflangHtml) {
	document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
	if (!hreflangHtml || !hreflangHtml.trim()) return;
	const tpl = document.createElement('template');
	tpl.innerHTML = hreflangHtml.trim();
	tpl.content.querySelectorAll('link[rel="alternate"]').forEach((node) => {
		document.head.appendChild(node);
	});
}

router.isReady().then(() => {
	updateMeta(router.currentRoute.value);
	router.beforeEach((to, _from, next) => {
		updateMeta(to);
		next();
	});
	// 先挂载再初始化 Firebase，避免阻塞首屏水合（减轻「闪一下再恢复」体感）
	app.mount('#app');
	void setupFirebaseClient(app);
});
